import React, { FunctionComponent } from 'react';

import share from '../../../images/share_icon_alt.svg';

import { FOHImage } from '../../ingredients';
import { FOHIconProps } from '../../typings';

export const FOHShareIconAlt: FunctionComponent<FOHIconProps> = props => (
  <FOHImage
    source={{ uri: share }}
    style={[{ width: 16, height: 16 }, props?.style]}
  />
);
